var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-hook", attrs: { id: "web-hook" } },
    [
      _c(
        "div",
        { staticClass: "web-hook-container" },
        [
          _c("AppBreadCrumb", {
            staticClass: "new-hook-bread-crumb",
            attrs: {
              paths: [{ title: _vm.$t("chatbotv2.addWebhook") }],
              select: true,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "page-name" }, [
              _c(
                "div",
                {
                  staticClass: "routes",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({ name: "integrations-webhook" })
                    },
                  },
                },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("integrations.webhooksNavLabel"))),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "arrow" }, [_vm._v(">")]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "web-hook-name" }, [
                _vm._v(
                  _vm._s(
                    _vm.form.name.toUpperCase() ||
                      _vm.$t("integrations.newWebhookTitle")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "button-container",
                on: { click: _vm.saveButtonClickHandler },
              },
              [
                _c("div", { staticClass: "save-button" }, [
                  _vm._v(_vm._s(_vm.$t("message.save"))),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.$validator.errors.items.length && _vm.isSubmitClicked
            ? _c(
                "a-alert",
                {
                  staticClass: "mb-2",
                  attrs: {
                    message: _vm.$t("message.error"),
                    showIcon: "",
                    type: "error",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "description" }, slot: "description" },
                    _vm._l(_vm.$validator.errors.items, function (err) {
                      return _c("div", [
                        _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(err.msg) +
                              "\n                    "
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c(
                "a-form",
                { staticClass: "d-flex flex-column justify-content-center" },
                [
                  _c("div", { staticClass: "form-subtitle" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("chatbotv2.webhookName"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { staticClass: "mb-0" },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("chatbotv2.yourWebHookName"),
                          name: _vm.$t("chatbotv2.yourWebHookName"),
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-subtitle" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("chatbotv2.webHookUrl"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    {
                      staticClass: "mb-0",
                      staticStyle: { position: "relative" },
                      attrs: { name: "url" },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        style: {
                          borderColor: _vm.urlError ? "red" : "#d9d9d9",
                        },
                        attrs: {
                          placeholder: _vm.$t("chatbotv2.yourWebHookUrl"),
                          name: _vm.$t("chatbotv2.webHookUrl"),
                        },
                        on: { blur: _vm.urlInputOnBlurHandler },
                        model: {
                          value: _vm.form.url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "url", $$v)
                          },
                          expression: "form.url",
                        },
                      }),
                      _vm._v(" "),
                      _vm.urlError
                        ? _c(
                            "label",
                            {
                              staticStyle: {
                                position: "absolute",
                                bottom: "-42px",
                                left: "0",
                                color: "red",
                                margin: "0",
                                padding: "0",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("chatbotv2.urlTypeError"))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-subtitle" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.webHookToken"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { staticClass: "mb-0" },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "chatbotv2.yourVerificationToken"
                          ),
                        },
                        model: {
                          value: _vm.form.verificationToken,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "verificationToken", $$v)
                          },
                          expression: "form.verificationToken",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "relative-header" }, [
                    _c("div", { staticClass: "form-subtitle" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.basicAuth"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex headers",
                        staticStyle: { gap: "12px" },
                      },
                      [
                        _c(
                          "a-form-item",
                          { staticClass: "mb-0 w-100" },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder: _vm.$t("chatbotv2.username"),
                              },
                              model: {
                                value: _vm.form.basicAuthentication.username,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.basicAuthentication,
                                    "username",
                                    $$v
                                  )
                                },
                                expression: "form.basicAuthentication.username",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-form-item",
                          { staticClass: "mb-0 w-100" },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder: _vm.$t("chatbotv2.password"),
                              },
                              model: {
                                value: _vm.form.basicAuthentication.password,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.basicAuthentication,
                                    "password",
                                    $$v
                                  )
                                },
                                expression: "form.basicAuthentication.password",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "headers-group" },
                    [
                      _c("div", { staticClass: "form-subtitle" }, [
                        _vm._v(
                          _vm._s(_vm.$t("integrations.httpHeadersSection"))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.anotherHeaders, function (header, index) {
                        return _c(
                          "div",
                          {
                            staticClass: "d-flex headers",
                            staticStyle: { gap: "12px" },
                          },
                          [
                            _c(
                              "a-form-item",
                              { staticClass: "mb-0 w-100" },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: _vm.$t("chatbotv2.enterKey"),
                                  },
                                  model: {
                                    value: header.key,
                                    callback: function ($$v) {
                                      _vm.$set(header, "key", $$v)
                                    },
                                    expression: "header.key",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-form-item",
                              { staticClass: "mb-0 w-100 header-input" },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: _vm.$t("chatbotv2.value"),
                                  },
                                  model: {
                                    value: header.value,
                                    callback: function ($$v) {
                                      _vm.$set(header, "value", $$v)
                                    },
                                    expression: "header.value",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "delete-button",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteHeader(index)
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v("delete")])],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-wrapper-switches" },
            [
              _c(
                "a-card",
                { staticClass: "mt-2 w-50" },
                [
                  _c("h5", { staticClass: "mb-5" }, [
                    _vm._v(_vm._s(_vm.$t("message.selectHooks"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.hooks, function (hook) {
                    return _c(
                      "div",
                      { key: hook.name, staticClass: "row mb-3" },
                      [
                        _c("span", { staticClass: "col-4" }, [
                          _vm._v(_vm._s(hook.value)),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          staticClass: "col-1",
                          attrs: { checked: _vm.selectOption(hook) },
                          on: {
                            change: function ($event) {
                              return _vm.onChange(hook.name)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: { id: "visibleBtn" },
                            on: {
                              click: function ($event) {
                                return _vm.openPreview(hook.name)
                              },
                            },
                          },
                          [
                            _c("md-icon", { attrs: { id: "visibleIcon" } }, [
                              _vm._v("visibility"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.previewActive
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "previewModal",
                title:
                  _vm.hookList[_vm.selectedHook].type + " - Webhook Örneği",
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.previewActive = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { id: "previewArea" } },
                [
                  _c("vue-json-pretty", {
                    attrs: { data: _vm.hookList[this.selectedHook] },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }